module.exports = __webpack_public_path__ + "static/freemasons-hall-inside-b248d26099c957a872acc1aa7709a8f9.jpg";